{
  "evm_nfts": [
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "305",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_Stanford.png",
      "metadata_accessed": "2023-09-28 15:05:02.746011 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/13",
      "name": "TRAILBLAZER_Stanford",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "306",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_ImperialCollegeLondon.png",
      "metadata_accessed": "2023-09-28 15:05:02.746014 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/12",
      "name": "TRAILBLAZER_Imperial College London",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "307",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_UCBerkeley.png",
      "metadata_accessed": "2023-09-28 15:05:02.746543 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/14",
      "name": "TRAILBLAZER_UC Berkeley",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "308",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_UIUC.png",
      "metadata_accessed": "2023-09-28 15:05:02.746194 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/15",
      "name": "TRAILBLAZER_UIUC",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "309",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_ImperialCollegeLondon.png",
      "metadata_accessed": "2023-09-28 15:05:02.746178 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/12",
      "name": "TRAILBLAZER_Imperial College London",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "310",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_UCBerkeley.png",
      "metadata_accessed": "2023-09-28 15:05:02.746174 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/14",
      "name": "TRAILBLAZER_UC Berkeley",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "311",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_UIUC.png",
      "metadata_accessed": "2023-09-28 15:05:02.746023 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/15",
      "name": "TRAILBLAZER_UIUC",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "312",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_UCBerkeley.png",
      "metadata_accessed": "2023-09-28 15:05:02.746102 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/14",
      "name": "TRAILBLAZER_UC Berkeley",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "313",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_UIUC.png",
      "metadata_accessed": "2023-09-28 15:05:02.746519 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/15",
      "name": "TRAILBLAZER_UIUC",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "325",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_ImperialCollegeLondon.png",
      "metadata_accessed": "2023-09-28 15:05:02.890797 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/12",
      "name": "TRAILBLAZER_Imperial College London",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "326",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_Stanford.png",
      "metadata_accessed": "2023-09-28 15:05:02.890772 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/13",
      "name": "TRAILBLAZER_Stanford",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "327",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_Stanford.png",
      "metadata_accessed": "2023-09-28 15:05:02.890827 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/13",
      "name": "TRAILBLAZER_Stanford",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "328",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_Stanford.png",
      "metadata_accessed": "2023-09-28 15:05:02.890739 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/13",
      "name": "TRAILBLAZER_Stanford",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "329",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_UIUC.png",
      "metadata_accessed": "2023-09-28 15:05:02.890775 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/15",
      "name": "TRAILBLAZER_UIUC",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "330",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_UCBerkeley.png",
      "metadata_accessed": "2023-09-28 15:05:02.890832 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/14",
      "name": "TRAILBLAZER_UC Berkeley",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "331",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_UIUC.png",
      "metadata_accessed": "2023-09-28 15:05:02.890873 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/15",
      "name": "TRAILBLAZER_UIUC",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "314",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_Stanford.png",
      "metadata_accessed": "2023-09-28 15:05:02.746483 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/13",
      "name": "TRAILBLAZER_Stanford",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "315",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_UCBerkeley.png",
      "metadata_accessed": "2023-09-28 15:05:02.746051 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/14",
      "name": "TRAILBLAZER_UC Berkeley",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "316",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_Stanford.png",
      "metadata_accessed": "2023-09-28 15:05:02.746164 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/13",
      "name": "TRAILBLAZER_Stanford",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "317",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_Stanford.png",
      "metadata_accessed": "2023-09-28 15:05:02.746018 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/13",
      "name": "TRAILBLAZER_Stanford",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "318",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_Stanford.png",
      "metadata_accessed": "2023-09-28 15:05:02.746572 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/13",
      "name": "TRAILBLAZER_Stanford",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "319",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_ImperialCollegeLondon.png",
      "metadata_accessed": "2023-09-28 15:05:02.746059 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/12",
      "name": "TRAILBLAZER_Imperial College London",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "320",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_Stanford.png",
      "metadata_accessed": "2023-09-28 15:05:02.746449 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/13",
      "name": "TRAILBLAZER_Stanford",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "321",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_Stanford.png",
      "metadata_accessed": "2023-09-28 15:05:02.746627 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/13",
      "name": "TRAILBLAZER_Stanford",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "322",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_Stanford.png",
      "metadata_accessed": "2023-09-28 15:05:02.746675 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/13",
      "name": "TRAILBLAZER_Stanford",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "323",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_Stanford.png",
      "metadata_accessed": "2023-09-28 15:05:02.746209 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/13",
      "name": "TRAILBLAZER_Stanford",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    },
    {
      "contract_addr": "oasis1qrels9582m4wf25guu5057wtg74jncvqay8u6947",
      "description": "Thank you for participating in the DeFi MOOC 2021,the first-ever MOOC in DeFi!",
      "eth_contract_addr": "0xea27EdC49882eDe0208A2863915819fb1DB3eFfB",
      "id": "324",
      "image": "ipfs://QmbaHVxK6Ru8p4SL3cZuzNmPNH6kE9y5TDFHWuGmKtzpto/TRAILBLAZER_UCBerkeley.png",
      "metadata_accessed": "2023-09-28 15:05:02.746142 +0000 UTC",
      "metadata_uri": "ipfs://QmYCGCCkmkphoJAT46penq8UCB5V7XACnV7swECt3TPpEN/14",
      "name": "TRAILBLAZER_UC Berkeley",
      "token_name": "DeFi MOOC 2021 NFT",
      "token_symbol": "MOOC2021",
      "token_total_supply": "331",
      "token_type": "ERC721"
    }
  ],
  "is_total_count_clipped": false,
  "total_count": 27
}
